export const QMS_CATEGORY_LABELS = {
  // Page titles
  LIST_TITLE: 'Kategorie',
  CREATE_TITLE: 'Dodaj kategorię',

  // Section headings
  SECTION_DETAILS: 'Szczegóły kategorii',

  // Field labels
  FIELD_NAME: 'Nazwa',
  FIELD_TAGS: 'Tagi',
  FIELD_DESCRIPTION: 'Opis',

  // Tag input
  BUTTON_ADD_TAG: 'Dodaj',
  TAG_HELPER: 'Enter tags separated by commas (e.g., Safety, HR, Policy).',

  // Buttons
  BUTTON_CREATE: 'Dodaj kategorię',
  BUTTON_CREATE_LOADING: 'Dodawanie kategorii…',
  BUTTON_CANCEL: 'Anuluj',

  // Empty state
  EMPTY_STATE_TITLE: 'Brak kategorii.',
  EMPTY_STATE_DESCRIPTION:
    'Dodaj kategorię, aby sprawnie porządkować i zarządzać dokumentami SZJ.',

  // Success
  CREATE_SUCCESS: 'Kategoria została dodana.',

  // List columns
  COLUMN_NAME: 'Nazwa',
  COLUMN_DESCRIPTION: 'Opis',
  COLUMN_TAGS: 'Tagi',
  COLUMN_CREATED_AT: 'Data utworzenia',
  COLUMN_STATUS: 'Status',
  COLUMN_ACTIONS: 'Akcje',

  // Search
  SEARCH_PLACEHOLDER: 'Szukaj po nazwie kategorii i tagach',

  // Tags display
  MORE_TAGS_SUFFIX: 'więcej',

  // Status labels
  STATUS_ACTIVE: 'Aktywny',
  STATUS_INACTIVE: 'Nieaktywny',

  // No results
  NO_RESULTS_TITLE: 'Nie znaleziono wyników.',
  NO_RESULTS_DESCRIPTION_SEARCH: 'Spróbuj zmienić kryteria wyszukiwania.',
  NO_RESULTS_DESCRIPTION_FILTER: 'Spróbuj zmienić ustawienia filtrów.',
  NO_RESULTS_DESCRIPTION_BOTH:
    'Spróbuj zmienić kryteria wyszukiwania lub filtry.',

  // Row actions
  ACTION_VIEW: 'Podgląd',
  ACTION_EDIT: 'Edytuj',

  // View page
  VIEW_TITLE: 'Podgląd kategorii',
  BUTTON_EDIT: 'Edytuj kategorię',
  STATUS_LABEL: 'Status:',
  VIEW_ERROR_TITLE: 'Nie można załadować danych kategorii.',
  VIEW_ERROR_DESCRIPTION: 'Spróbuj odświeżyć stronę.',
  VIEW_ERROR_RELOAD: 'Odśwież',

  // View page tabs
  TAB_BASIC_INFO: 'Podstawowe informacje',
  TAB_QMS_DOCUMENTS: 'QMS Documents',

  // View page fields
  FIELD_CREATED_AT: 'Data utworzenia',
  FIELD_CREATED_BY: 'Utworzono przez',
  FIELD_UPDATED_BY: 'Zmodyfikowane przez',
  FIELD_UPDATED_AT: 'Data modyfikacji',

  // QMS Documents tab empty state
  QMS_DOCUMENTS_EMPTY: 'No QMS documents associated with this category.',

  // Edit page
  EDIT_TITLE: 'Edytuj kategorię',
  BUTTON_SAVE: 'Zapisz',
  BUTTON_SAVE_LOADING: 'Zapisywanie…',
  EDIT_SUCCESS: 'Kategoria została zaktualizowana.',

  // Status toggle dialog
  STATUS_DIALOG_ACTIVATE_TITLE: 'Aktywować kategorię?',
  STATUS_DIALOG_DEACTIVATE_TITLE: 'Dezaktywować kategorię?',
  STATUS_DIALOG_ACTIVATE_PREFIX: 'Czy na pewno chcesz aktywować kategorię ',
  STATUS_DIALOG_ACTIVATE_SUFFIX: ' category?',
  STATUS_DIALOG_DEACTIVATE_PREFIX:
    'Czy na pewno chcesz dezaktywować kategorię ',
  STATUS_DIALOG_DEACTIVATE_SUFFIX: ' category?',
  STATUS_DIALOG_CONFIRM_ACTIVATE: 'Aktywuj',
  STATUS_DIALOG_CONFIRM_ACTIVATING: 'Aktywowanie…',
  STATUS_DIALOG_CONFIRM_DEACTIVATE: 'Dezaktywuj',
  STATUS_DIALOG_CONFIRM_DEACTIVATING: 'Dezaktywowanie…',

  // Status toggle results
  STATUS_SUCCESS_ACTIVATED: 'Kategoria została aktywowana.',
  STATUS_SUCCESS_DEACTIVATED: 'Kategoria została dezaktywowana.',
  STATUS_ERROR_ALREADY_ACTIVE: 'Kategoria jest już aktywna.',
  STATUS_ERROR_ALREADY_INACTIVE: 'Kategoria jest już nieaktywna.',
  STATUS_ERROR_GENERIC: 'Nie udało się zaktualizować statusu kategorii.',
  STATUS_ERROR_UNEXPECTED: 'Nieoczekiwany błąd. Spróbuj ponownie.',
} as const;
